import React from 'react';
import ScrollTrigger from 'react-scroll-trigger';
import BlackOverlay from '../../partials/black_overlay';
import Footer from '../footer';
import NavBar from '../navbar';
import { Animated } from "react-animated-css";
import Contact from '../contact';
import Logo from '../logo';
import Burger from '../burger';

// August 16th: Refactored for responsiveness
class Three extends React.Component {
    state = {
        navBarTransparent: false,
        menuOpen: false
    }
    componentDidMount = () => { window.scrollTo(0, 0); }
    onEnterViewport = () => this.setState({ navBarTransparent: true });
    onExitViewport = () => this.setState({ navBarTransparent: false });
    onToggleMenu = () => this.setState({ menuOpen: !this.state.menuOpen });

    render() {
        const { navBarTransparent, menuOpen } = this.state, { nbs } = this.props;

        return (
            <section>
                <div className={`w3-top nav-bar  ${navBarTransparent ? 'nav-bar-transparent' : 'w3-card'}`}>
                    <Contact />
                    <div className={`w3-bar d-flex flex-row  w3-content font-11`} style={{ height: 70 }}>
                        <Logo />
                        <NavBar nbs={nbs} />
                        <a className="w3-button w3-padding-large ml-auto w3-hide-large flex-row justify-content-center burger bg-black" onClick={this.onToggleMenu} title="Toggle Navigation Menu">
                            <i className="fa fa-bars white align-self-center font-20" />
                        </a>
                    </div>
                </div>
                <div className={`w3-sidebar w3-bar-block w3-card w3-animate-right w3-center bg-black white ${menuOpen ? '' : 'w3-hide'}`}
                    style={{ right: 0, width: '90%', zIndex: 4 }}>
                    <Burger onToggleMenu={this.onToggleMenu} />
                </div>
                <div>
                    <div className="hero3" style={{ position: 'relative', background: 'url("/images/backgrounds/little-girl-dribling.jpg") no-repeat center top', backgroundSize: 'cover' }}>
                        <BlackOverlay />
                        <Animated animationIn="zoomInDown" className="hero3 d-flex flex-column justify-content-center">
                            <h1 className="align-self-center hero-text anton text-center w-100 line1" style={{ fontSize: 120 }}>3v3</h1>
                            <h2 className="align-self-center heroish-text anton text-center w-100 line1" style={{ fontSize: 60 }}>AT ITS BEST</h2>
                        </Animated>
                    </div>
                    {React.cloneElement(this.props.children, this.props)}
                </div>

                <ScrollTrigger onEnter={this.onEnterViewport} onExit={this.onExitViewport} triggerOnLoad={true}
                    style={{ position: 'absolute', top: 150, height: 50 }} throttleScroll={0} />

                <div style={{ height: 48 }} />
                <footer className={`w3-container p-2 w3-black show`}>
                    <Footer />
                </footer>
            </section>
        )
    }
}

export default Three;



// WEBPACK FOOTER //
// ./src/components/layouts/three/index.js